// extracted by mini-css-extract-plugin
export default {"wrapper":"AchievementsPage_wrapper__PiMwZ"};